import type { ClientItem } from "owa-mail-store";
import type Item from "owa-service/lib/contract/Item";
import { DecryptionState } from "owa-mail-store/lib/store/schema/DecryptionState";
import { isAccountFeatureEnabled } from "owa-feature-flags";

/**
 * Check if addin decryption is currently in progress for the given item.
 * @param item - The item to check (will be cast to ClientItem internally)
 * @returns true if decryption is in progress (InProgress or NotStarted), false otherwise
 */
export default function checkAddinDecryptionInProgress(item: Item): boolean {
    // Cast to ClientItem to access AddinData
    const clientItem = item as ClientItem;
    
    // Check if the addin-decryption feature is enabled
    if (!isAccountFeatureEnabled("addin-decryption", clientItem.MailboxInfo)) {
        return false;
    }
    
    return (clientItem.AddinData?.DecryptionState === DecryptionState.InProgress ||
        clientItem.AddinData?.DecryptionState === DecryptionState.NotStarted);
}
